module.exports = __webpack_public_path__ + "img/info-pulldown.d33db284.svg";